import ConsultantCreateConsultantInterest from './ConsultantCreateConsultantInterest';
export default ConsultantCreateConsultantInterest;